export default __webpack_public_path__ + "static/media/PDFReport-Interior-Pg5.75a680b4.png";